import { TriangleAlert } from "lucide-react";

import { m } from "../../paraglide/messages.js";
import { AuthLayout } from "../../ui/AuthLayout";
import { Button } from "../../ui/Button";
import { StateIcon } from "../../ui/StateIcon";

/** A page that broke: it says nothing of the practice's is lost, that the publications go out anyway, and offers to
 * load the page again, which most often mends it. */
export function ErrorPage() {
  return (
    <AuthLayout title={m.error_page_title()} state={<StateIcon icon={TriangleAlert} tone="danger" />}>
      <p className="text-sm text-text-muted">{m.error_page_text()}</p>
      <Button className="w-full" onClick={() => window.location.reload()}>
        {m.error_page_reload()}
      </Button>
    </AuthLayout>
  );
}
